import { Alert, ButtonANTD } from '@zennolab_platform/webui-kit/dist/ui/antdComponents';
import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';

import { Centered, Toolbar } from '../layout';

interface Props {
  error?: string;
  inFrame: boolean;
  onLogin: () => void;
  onRetry: () => void;
}

/** Shown whenever there is no session: never an endless spinner. */
export function LoginScreen({ error, inFrame, onLogin, onRetry }: Props) {
  const { t } = useFormatMessage();
  return (
    <Centered>
      <h1>{t({ id: 'shell.login.title', defaultMessage: 'Требуется вход', description: 'Заголовок экрана входа' })}</h1>
      <p>
        {inFrame
          ? t({
              id: 'shell.login.frameHint',
              defaultMessage: 'Войдите в новой вкладке, затем нажмите «Повторить».',
              description: 'Подсказка экрана входа внутри фрейма UA2',
            })
          : t({
              id: 'shell.login.hint',
              defaultMessage: 'Войдите через Keycloak, чтобы продолжить.',
              description: 'Подсказка экрана входа',
            })}
      </p>
      {error && <Alert type="error" title={error} />}
      <Toolbar>
        {inFrame ? (
          // Keycloak cannot complete a login inside UA2's frame; the new tab can, then Retry picks the session up.
          <ButtonANTD type="primary" href={window.location.href} target="_blank" rel="noopener noreferrer">
            {t({
              id: 'shell.login.openInNewTab',
              defaultMessage: 'Открыть в новой вкладке',
              description: 'Кнопка экрана входа внутри фрейма UA2',
            })}
          </ButtonANTD>
        ) : (
          <ButtonANTD type="primary" onClick={onLogin}>
            {t({ id: 'shell.login.signIn', defaultMessage: 'Войти', description: 'Кнопка экрана входа' })}
          </ButtonANTD>
        )}
        <ButtonANTD onClick={onRetry}>
          {t({
            id: 'shell.common.retry',
            defaultMessage: 'Повторить',
            description: 'Кнопка повтора запроса или проверки сессии',
          })}
        </ButtonANTD>
      </Toolbar>
    </Centered>
  );
}
